<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>
    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1" foot-clone>
      <template #thead-top="data">
        <b-tr>
          <b-th colspan="3" style="text-align: center"></b-th>
          <b-th colspan="2" style="text-align: center">单价信息</b-th>
          <b-th colspan="2" style="text-align: center">出勤情况</b-th>
          <b-th colspan="3" style="text-align: center">工作量</b-th>
          <b-th colspan="1" style="text-align: center"></b-th>
        </b-tr>
      </template>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <!--      <template v-slot:cell(contractorName)="data">-->
      <!--        <div style="color: #4caedc" @click="showDetail(data.item.contractorName)">{{ data.item.contractorName }}</div>-->
      <!--      </template>-->
      <!--      <template v-slot:cell(joinDate)="data">-->
      <!--        {{moment(data.item.joinDate).format("YYYY-MM-DD")}}-->
      <!--      </template>-->
      <!--      <template v-slot:cell(leaveDate)="data">-->
      <!--        {{-->
      <!--          (data.item.leaveDate === '' || data.item.leaveDate === undefined) ? '-' : moment(data.item.leaveDate).format("YYYY-MM-DD")-->
      <!--        }}-->
      <!--      </template>-->
      <template v-slot:cell(jobTypeName)="data">
        {{ data.item.jobTypeName ? data.item.jobTypeName : '/' }}
      </template>
      <template v-slot:cell(price)="data">
        {{ Number(data.item.price).toFixed(2) }}
      </template>
      <template v-slot:cell(attendNum)="data">
        {{ Number(data.item.attendNum).toFixed(2) }}
      </template>
      <template v-slot:cell(workNum)="data">
        {{ Number(data.item.workNum).toFixed(2) }}
      </template>
      <template v-slot:cell(jobTypeId)="data">
        {{ (Number(data.item.attendNum || 0) * Number(data.item.workNum || 0)).toFixed(2) }}
      </template>
      <template v-slot:cell(remark)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.remark)">{{ data.item.remark }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
      <template v-slot:foot()="scope">
        <div class="text-nowrap" :style="{textAlign:'center'}"></div>
      </template>
      <template v-slot:foot(index)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
      </template>
      <template v-slot:foot(laborFee)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'laborFee') }}</div>
      </template>
    </b-table>
    <!--    <table style="font-size:12px;">-->
    <!--      <thead>-->
    <!--      <tr>-->
    <!--        <th style="width: 50px;" class="text-center">序号</th>-->
    <!--        <th style="width: 120px;" class="text-center">劳务工种</th>-->
    <!--        <th style="width: 120px;" class="text-center">劳务班组</th>-->
    <!--        <th style="width: 120px;" class="text-center">用工人数</th>-->
    <!--        <th style="width: 120px;" class="text-center">费项名称</th>-->
    <!--        <th style="width: 100px;" class="text-center">职务</th>-->
    <!--        <th style="width: 100px;" class="text-center">人数</th>-->
    <!--        <th style="width: 100px;" class="text-center">单价</th>-->
    <!--        <th style="width: 100px;" class="text-center">单位</th>-->
    <!--        <th style="width: 100px;" class="text-center">数量</th>-->
    <!--        <th style="width: 100px;" class="text-center">单位</th>-->
    <!--        <th style="width: 120px;" class="text-center">金额（元）</th>-->
    <!--        <th style="width: 140px;" class="text-center">备注</th>-->
    <!--      </tr>-->
    <!--      </thead>-->
    <!--      <tbody>-->
    <!--      <tr v-for="(item, index) in items" :key="index">-->
    <!--        <td style="width: 50px;" class="text-center">{{ index + 1 }}</td>-->
    <!--        <td v-if="item.groupCount > 0" :rowspan="item.groupCount" class="text-center">{{ item.laborType }}</td>-->
    <!--        <td v-if="item.teamGroupCount > 0" :rowspan="item.teamGroupCount" class="text-center">{{ item.laborTeam }}</td>-->
    <!--        <td style="width: 120px;" class="text-center">-->
    <!--          {{ item.employeeNum }}-->
    <!--        </td>-->
    <!--        <td style="width: 120px;" class="text-center">{{ item.feeItem }}</td>-->
    <!--        <td style="width: 120px;" class="text-center">{{ item.dutyName }}</td>-->
    <!--        <td style="width: 100px;" class="text-center">{{ item.laborNum }}</td>-->
    <!--        <td style="width: 100px;" class="text-center">{{ item.laborPrice }}</td>-->
    <!--        <td style="width: 100px;" class="text-center">{{ item.unitLabel }}</td>-->
    <!--        <td style="width: 100px;" class="text-center">{{ item.num }}</td>-->
    <!--        <td style="width: 100px;" class="text-center">{{ item.laborUnitLabel }}</td>-->
    <!--        <td style="width: 120px;" class="text-center">{{ Number(item.laborFee).toFixed(2) }}</td>-->
    <!--        <td style="width: 140px;" class="text-center" @click="showDetail(item.remark)">-->
    <!--          <div-->
    <!--              style="width: 100%; color: #4caedc;overflow: hidden;white-space: nowrap; text-overflow: ellipsis; text-align: center; padding: 6px; box-sizing: border-box">-->
    <!--            {{ item.remark }}-->
    <!--          </div>-->
    <!--        </td>-->
    <!--      </tr>-->
    <!--      </tbody>-->
    <!--      <tfoot>-->
    <!--      <tr>-->
    <!--        <td></td>-->
    <!--        <td class="text-center">合计</td>-->
    <!--        <td></td>-->
    <!--        <td class="text-center">{{ sumNum(items, 'employeeNum', 0) }}</td>-->
    <!--        <td></td>-->
    <!--        <td></td>-->
    <!--        <td></td>-->
    <!--        <td></td>-->
    <!--        <td></td>-->
    <!--        <td></td>-->
    <!--        <td></td>-->
    <!--        <td class="text-center">{{ sumNum(items, 'laborFee') }}</td>-->
    <!--        <td></td>-->
    <!--      </tr>-->
    <!--      </tfoot>-->
    <!--    </table>-->
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "itsLaborDailyDetail",
  data() {
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'jobTypeName', label: '劳务工种名称', width: '120px'},
        {key: 'feeItem', label: '费项名称', width: '120px'},
        {key: 'price', label: '单价', width: '100px'},
        {key: 'priceUnit', label: '单位', width: '100px'},
        {key: 'attendNum', label: '数量', width: '100px'},
        {key: 'attendUnitLabel', label: '单位', width: '100px'},
        {key: 'workNum', label: '数量', width: '100px'},
        {key: 'workUnitLabel', label: '单位', width: '100px'},
        {key: 'jobTypeId', label: '小计', width: '100px'},
        {key: 'laborFee', label: '金额（元）', width: '100px'},
        {key: 'remark', label: '备注', width: '160px'},
      ],
      items: [],
      employeeNumTotal: 0,
      laborFeeTotal: 0
    }
  },
  created() {
    // this.items = this.addGroupCount(JSON.parse(this.$route.query.data))
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    // addGroupCount(list) {
    //   let result = []
    //   let i = 0
    //   while (i < list.length) {
    //     let count = 1
    //     // 找到连续相同 laborType 的数量
    //     while (
    //         i + count < list.length &&
    //         list[i + count].laborType === list[i].laborType
    //         ) {
    //       count++
    //     }
    //     // 给分组的第一条设置 groupCount，其余为 0
    //     for (let j = 0; j < count; j++) {
    //       result.push({
    //         ...list[i + j],
    //         groupCount: j === 0 ? count : 0
    //       })
    //     }
    //     i += count
    //   }
    //   return result
    // },
    addGroupCount(list) {
      let result = [];
      let i = 0;
      // 外层循环：按 laborType 分组
      while (i < list.length) {
        const currentLaborType = list[i].laborType;
        let laborTypeCount = 1;

        // 第一步：先计算当前 laborType 的总数量（确定 laborType 分组范围）
        while (i + laborTypeCount < list.length && list[i + laborTypeCount].laborType === currentLaborType) {
          laborTypeCount++;
        }

        // 第二步：在当前 laborType 分组内，按连续的 laborTeamId 细分
        let j = 0; // j 是当前 laborType 分组内的索引（0 ~ laborTypeCount-1）
        while (j < laborTypeCount) {
          const currentTeamId = list[i + j].laborTeamId;
          let teamCount = 1;

          // 计算当前 teamId 的连续数量（仅在当前 laborType 分组内）
          while (
              j + teamCount < laborTypeCount && // 不超出当前 laborType 分组范围
              list[i + j + teamCount].laborTeamId === currentTeamId
              ) {
            teamCount++;
          }

          // 给当前 team 分组的每条数据添加字段
          for (let k = 0; k < teamCount; k++) {
            const originalItem = list[i + j + k];
            result.push({
              ...originalItem,
              groupCount: j === 0 ? laborTypeCount : 0, // 原逻辑：laborType 分组仅第一条存总数
              teamGroupCount: k === 0 ? teamCount : 0 // 新增：连续 teamId 分组仅第一条存总数
            });
          }

          j += teamCount; // 移动到下一个 team 分组
        }

        i += laborTypeCount; // 移动到下一个 laborType 分组
      }
      return result;
    },
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key, n = 2) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(n, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    }
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed; /* 使表格宽度固定 */
}

th, td {
  padding: 8px;
  text-align: left;
  border: 1px solid #ddd;
}

th {
  border: 1px solid #ddd;
  background-color: #f4f4f4;
  text-align: center;
}
</style>